import { Link } from "react-router-dom";
import { hotList, articles } from "@/mocks/articles";

function formatHeat(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)} 万` : `${n}`;
}

export default function HotRanking() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center">
          <i className="ri-fire-fill text-background-50" />
        </span>
        <h2 className="font-heading font-black text-lg text-foreground-950">热榜 · 24 小时</h2>
      </div>
      <ol className="mt-5 space-y-1">
        {hotList.map((item, i) => {
          const article = articles.find((a) => a.id === item.id);
          return (
            <li key={item.id}>
              <Link
                to={`/article/${item.id}`}
                className="group flex items-start gap-3 py-3 border-b border-background-200 last:border-b-0 cursor-pointer"
              >
                <span
                  className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${
                    i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-500">
                    {article?.categoryName} · {formatHeat(item.heat)} 热度
                  </span>
                </span>
              </Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
}